import PropTypes from "prop-types";
import Error from "./error";
import RetryButton from "../RetryButton";
import styles from "./index.css";
import FaceEmoji from "../FaceEmoji";
import { DISAPPOINTED } from "../FaceEmoji/constants";
import classnames from "classnames";

const PageLoadError = ({ reinitialise, isAppOnline, children }) => (
  <div className={styles.pageLoadError}>
    <FaceEmoji type={DISAPPOINTED} className={styles.icon} />
    <Error isAppOnline={isAppOnline}>{children}</Error>
    <RetryButton
      className={classnames({
        [styles.retryButton]: true,
        [styles.retryButtonOnline]: isAppOnline
      })}
      action={reinitialise}
    />
  </div>
);

PageLoadError.propTypes = {
  reinitialise: PropTypes.func.isRequired,
  isAppOnline: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default PageLoadError;
